<template>
    <div>
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                <tr class="">
                    <th class="tituloProyecto" width="50%">
                        {{ proyecto.fields.nombre }}
                    </th>
                    <th class="precioProyecto text-right" v-if="presentacion.fields.precios">
                        <!--{{ formatPrice(proyecto.fields.precio_final) }}-->
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td colspan="2" class="fullWidth pr-0">
                        <div class="v-data-table v-data-table--dense theme--light">
                            <div class="v-data-table__wrapper">
                                <table class="v-data-table" v-for="(tipoProducto, key) in tiposProductosFiltrados(proyecto.id)" :key="'tipoProducto' + key">
                                    <thead>
                                    <tr>
                                        <th>
                                            {{ tipoProducto.fields.nombre }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(producto, key) in productosFiltrados(proyecto.id, tipoProducto.id)" :key="'producto' + key">
                                        <td class="producto">
                                            <p class="mb-0">{{ producto.fields.nombre }}</p>

                                            <small>
                                                {{ conceptosFiltrados(proyecto.id, producto.id).map(concepto => concepto.fields.nombre).join(" | ") }}
                                            </small>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: "Proyecto",
    props: {
        proyecto: {
            required: true,
            type: Object,
        },
    },
    computed: {
        ...mapState(['presentacion']),
        ...mapGetters(['tiposProductosFiltrados', 'productosFiltrados', 'conceptosFiltrados']),
    }
}
</script>

<style scoped>

.tituloProyecto {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120%;
    line-height: 2;
    font-weight: bold !important;
}

.precioProyecto {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120%;
    line-height: 2;
    font-weight: bold !important;
}

.producto {
    padding-left: 30px;
}

.fullWidth {
    width: 100% !important;
}

</style>
